import {editorClasses as defaultEditorClasses} from '@minimal/components/editor';

export const editorClasses = {
  ...defaultEditorClasses,
};
